import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL_V3, get } from "../api";

export interface BillDataPlan {
  code: string;
  name: string;
  amount: number;
  validity: string | null;
  volume: string | null;
  type: string | null;
}

/**
 * Data plans for a network from the provider-agnostic bills layer (/v3/bills).
 */
function useBillDataPlans(
  serviceType: string,
  options?: QueryObserverOptions<APIResponse<BillDataPlan[]>, APIError>
) {
  const {
    data: plans,
    isLoading: fetchingPlans,
    isError: isPlansError,
    error: plansError,
  } = useQuery<APIResponse<BillDataPlan[]>, APIError>(
    ["bills-data-plans", serviceType],
    async () =>
      await get(
        API_URL_V3 +
          `/bills/data/plans?service_type=${encodeURIComponent(serviceType)}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      ),
    {
      enabled: !!serviceType,
      ...options,
    }
  );

  return {
    plans: plans?.data || [],
    fetchingPlans,
    isPlansError,
    plansError,
  };
}

export default useBillDataPlans;
